import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { Container, Row, Col } from "reactstrap";
import logoWhite from "../../assets/eksiogluPictures/logo-white.png";

// Görselleri import et
const importAll = (r) => r.keys().map(r);
const images = importAll(
  require.context(
    "../../assets/img/presentation-page",
    false,
    /\.(jpg|jpeg|png)$/
  )
);

const HeadersMainSlider = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <div className="header-slider" style={{ position: "relative" }}>
      <style>{`
        .header-slider .slick-slider,
        .header-slider .slick-list,
        .header-slider .slick-track,
        .header-slider .slick-slide {
          height: 100vh !important;
        }
        .header-slider .slick-dots {
          bottom: 25px;
        }
        .header-slider .slick-dots li button:before {
          font-size: 12px;
          color: #fff;
          opacity: 0.6;
        }
        .header-slider .slick-dots li.slick-active button:before {
          color: #fff;
          opacity: 1;
        }

        /* Sol üst logo alanı */
        .header-logo {
          position: absolute;
          top: 30px;
          left: 40px;
          z-index: 20;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .header-logo img {
          width: 70px;
          height: auto;
        }
        .header-logo h2 {
          color: white;
          font-weight: 700;
          font-size: 1.6rem;
          margin: 0;
        }

        @media (max-width: 768px) {
          .header-logo {
            top: 20px;
            left: 20px;
            flex-direction: column;
            align-items: flex-start;
          }
          .header-logo img {
            width: 55px;
          }
          .header-logo h2 {
            font-size: 1.2rem;
          }
        }
      `}</style>

      {/* Logo ve başlık */}
      <div className="header-logo">
        <img src={logoWhite} alt="Ekşioğlu Hukuk Logo" />
        <h2>EKŞİOĞLU HUKUK</h2>
      </div>

      <Slider ref={sliderRef} {...settings}>
        {images.map((img, index) => (
          <div key={index} style={{ position: "relative", height: "100vh" }}>
            <div
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                height: "100%",
                filter: "brightness(60%)",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            />
            <Container style={{ position: "relative", zIndex: 2 }}>
              <Row
                className="align-items-center"
                style={{ minHeight: "100vh" }}
              >
                <Col md="8" className="text-white">
                  <h1
                    style={{
                      fontSize: isMobile ? "2rem" : "3rem",
                      fontWeight: 700,
                      lineHeight: 1.2,
                    }}
                  >
                    Hukukun Gücü, Ekşioğlu Hukuk’ta
                  </h1>
                  <p
                    style={{
                      fontSize: isMobile ? "1rem" : "1.1rem",
                      color: "#e2e8f0",
                      marginTop: "1rem",
                      maxWidth: 600,
                    }}
                  >
                    Türkiye genelinde uzman avukat kadromuzla, müvekkillerimizin
                    haklarını savunuyor, güvenilir ve profesyonel danışmanlık
                    sağlıyoruz.
                  </p>
                  <a
                    href="/hakkimizda"
                    style={{
                      display: "inline-block",
                      marginTop: "1.5rem",
                      padding: "0.75rem 1.5rem",
                      backgroundColor: "#ffffff",
                      color: "#0F172A",
                      borderRadius: "0.375rem",
                      fontWeight: "bold",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#e5e7eb")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "#ffffff")
                    }
                  >
                    Hizmetlerimizi Keşfedin
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeadersMainSlider;
